const actions = {
  setCurrency({ commit }, params) {
    commit('changeCurrency', params)
    this.$auth.$storage.setUniversal('currency', params)
  },
}
export default actions
